import { request } from "../../../services/api"
import type { BaseApiResponse, BasePagination } from "../../../types/api.ts"
import type {
  ProjectChecklistChartItem,
  ProjectChecklistFilterOptions
} from "../redux/project.types.ts"
import type { ProjectChecklistItem } from "../types/project-checklists.types.tsx"
import type {
  ChecklistChartDataParams,
  ChecklistItemData,
  ChecklistItemPatchData,
  ChecklistItemsParams
} from "./services.types.ts"

const BASE_URL = `/project-management/checklist-item`

const PATHS = {
  getChecklistItems: `${BASE_URL}/`,
  getFilterOptions: `${BASE_URL}/filter_options/`,
  createChecklistItem: `${BASE_URL}/`,
  getChecklistItem: (id: string) => `${BASE_URL}/${id}/`,
  updateChecklistItem: (id: string) => `${BASE_URL}/${id}/`,
  patchChecklistItem: (id: string) => `${BASE_URL}/${id}/`,
  deleteChecklistItem: (id: string) => `${BASE_URL}/${id}/`,
  reorderChecklistItems: `${BASE_URL}/bulk-reorder/`,
  //
  getChartData: `${BASE_URL}/burndown/`
}

export const getChecklistItems = async (params: ChecklistItemsParams) => {
  return request.api.get<
    BasePagination<ProjectChecklistItem>,
    BaseApiResponse<unknown>
  >(PATHS.getChecklistItems, params)
}

export const getChecklistItemsFilterOptions = async (project_id: string) => {
  return request.api.get<
    ProjectChecklistFilterOptions,
    BaseApiResponse<unknown>
  >(PATHS.getFilterOptions, { project_id })
}

export const getChecklistChartData = async (
  params: ChecklistChartDataParams
) => {
  return request.api.get<ProjectChecklistChartItem[], BaseApiResponse<unknown>>(
    PATHS.getChartData,
    params
  )
}

export const createChecklistItem = async (data: ChecklistItemData) => {
  return request.api.post<
    BaseApiResponse<ProjectChecklistItem>,
    BaseApiResponse<unknown>
  >(PATHS.createChecklistItem, data)
}

export const getChecklistItem = async (id: string) => {
  return request.api.get<ProjectChecklistItem, BaseApiResponse<unknown>>(
    PATHS.getChecklistItem(id)
  )
}

export const updateChecklistItem = async (
  id: string,
  data: ChecklistItemData
) => {
  return request.api.put<
    BaseApiResponse<ProjectChecklistItem>,
    BaseApiResponse<unknown>
  >(PATHS.updateChecklistItem(id), data)
}

export const patchChecklistItem = async ({
  id,
  ...data
}: ChecklistItemPatchData) => {
  return request.api.patch<
    BaseApiResponse<ProjectChecklistItem>,
    BaseApiResponse<unknown>
  >(PATHS.patchChecklistItem(id), data)
}

export const deleteChecklistItem = async (id: string) => {
  return request.api.delete<BaseApiResponse<unknown>, BaseApiResponse<unknown>>(
    PATHS.deleteChecklistItem(id)
  )
}

export const reorderChecklistItems = async (data: {
  items: { id: string; order: number }[]
}) => {
  return request.api.post<BaseApiResponse<unknown>, BaseApiResponse<unknown>>(
    PATHS.reorderChecklistItems,
    data
  )
}
